// import { create } from "zustand";

// export type Theme = "light" | "dark" | "custom";

// const getInitialTheme = (): Theme =>
//     (localStorage.getItem("theme") as Theme) || "light";

// const applyTheme = (theme: Theme) => {
//     document.documentElement.classList.remove("light", "dark", "custom");
//     document.documentElement.classList.add(theme);
// };

// export const useThemeStore = create<{
//     theme: Theme;
//     setTheme: (t: Theme) => void;
// }>((set) => {
//     const theme = getInitialTheme();
//     applyTheme(theme);

//     return {
//         theme,
//         setTheme: (theme) => {
//             applyTheme(theme);
//             localStorage.setItem("theme", theme);
//             set({ theme });
//         }
//     };
// });



import { create } from "zustand";

// Nayi theme "teal" ko type mein add kiya
export type Theme = "light" | "dark" | "custom" | "teal" | "ocean" | "mono" | "glass";

// Pehli baar load hone par agar localStorage khali ho, to "teal" default hogi
const getInitialTheme = (): Theme =>
    (localStorage.getItem("theme") as Theme) || "teal";

// Exported so pages that apply the theme themselves (the auth screens) use the
// same class mapping: the "teal" theme's CSS class is "teal-theme".
export const applyTheme = (theme: Theme) => {
    // Sabhi purani classes remove karein
    document.documentElement.classList.remove("light", "dark", "custom", "teal", "teal-theme", "ocean-theme", "mono", "glassy");
    
    // Agar teal select hua hai to CSS ki sahi class lagayein
    if (theme === "teal") {
        document.documentElement.classList.add("teal-theme");
    } else if (theme === "ocean") {
        // The original teal palette, offered as "Teal" now that Default is orange.
        document.documentElement.classList.add("ocean-theme");
    } else if (theme === "glass") {
        // "glass" is already a utility class in themes.css.
        document.documentElement.classList.add("glassy");
    } else if (theme === "custom") {
        // Vibrant is a dark theme: "dark" turns on Tailwind's dark: styles,
        // and .custom (later in themes.css) overrides .dark's colours.
        document.documentElement.classList.add("dark", "custom");
    } else {
        document.documentElement.classList.add(theme);
    }
};

export const useThemeStore = create<{
    theme: Theme;
    setTheme: (t: Theme) => void;
}>((set) => {
    const theme = getInitialTheme();
    applyTheme(theme);

    return {
        theme,
        setTheme: (theme) => {
            applyTheme(theme);
            localStorage.setItem("theme", theme);
            set({ theme });
        }
    };
});